





















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { ExternalUser } from '@/models/externalUser';
import { appliedLessonWebservice } from '@/webservices/appliedlesson';
import type { Project } from '@/models/project';
import MobileDetect from 'mobile-detect';
import type { ProjectUser } from '@/models/projectUser';
import type { Trade } from '@/models/trade';
import type { Phase } from '@/models/phase';
import TradesToDosFilters from '@/components/toDoWizard/trade/TradesToDosFilters.vue';
import type { User } from '@/models/user';
import ProjectChooser from '@/components/utils/ProjectChooser.vue';
import type { AppliedLesson } from '@/models/appliedlesson';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'TradeToDosList',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        TradesToDosFilters,
        ProjectChooser,
    },
})
export default class TradeToDosList extends Vue {
    private isModalActive: boolean = false;
    private isFirstSearch: boolean = true;
    private errors: string[] = [];
    private referrer: string = '';

    private selectedResponsibleUsers: ProjectUser[] = [];
    private selectedTrades: Trade[] = [];
    private selectedPhase: Phase = {} as Phase;
    private appliedLessons: AppliedLesson[] = [];
    private isLoadingTasks: boolean = false;

    @Getter('project/selectedProject') private selectedProject: Project;

    @Watch('selectedProject')
    private onSelectedProjectChange() {
        this.appliedLessons = [];
    }

    private mounted() {
        if (this.$route.query.hasOwnProperty('referrer')) {
            this.referrer = this.$route.query.referrer.toString();
            this.isModalActive = true;
        }
    }

    private back() {
        this.$router.push('/projects');
    }

    private get isDesktop() {
        const isNotDesktop = window.matchMedia('only screen and (max-width: 1300px)').matches;
        const md = new MobileDetect(window.navigator.userAgent);
        return !(md.mobile() || md.phone() || md.tablet() || isNotDesktop);
    }

    private load() {
        if (!this.verification()) {
            return;
        }
        this.referrer = '';
        this.isLoadingTasks = true;

        appliedLessonWebservice
            .getProjectOpenTasks(
                this.selectedTrades,
                this.selectedPhase,
                this.selectedResponsibleUsers,
                this.selectedProject
            )
            .then((res) => {
                this.appliedLessons = res.data;

                this.appliedLessons.forEach((applied_lesson) => {
                    if (applied_lesson.external_responsible_user !== null) {
                        applied_lesson.responsible_user = this.mapUserToProjectUser(
                            applied_lesson.external_responsible_user,
                            true
                        );
                        applied_lesson.external_responsible_user = null;
                    } else if (applied_lesson.internal_responsible_user !== null) {
                        applied_lesson.responsible_user = this.mapUserToProjectUser(
                            applied_lesson.internal_responsible_user,
                            false
                        );
                        applied_lesson.internal_responsible_user = null;
                    }
                });
                this.isFirstSearch = false;
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.isLoadingTasks = false;
            });
    }

    private sendEmail() {
        if (!this.verification()) {
            return;
        }
        this.referrer = '';

        appliedLessonWebservice
            .emailTheOpenTasks(
                this.selectedTrades,
                this.selectedPhase,
                this.selectedResponsibleUsers,
                this.selectedProject
            )
            .then((res) => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: this.$i18n.t('toastMessages.update.emailedOpenTasks').toString(),
                    type: 'is-success',
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private mapUserToProjectUser(user: User | ExternalUser, isExternal: boolean) {
        const responsible_user: ProjectUser = {
            unique_identifier: Math.floor(Math.random() * 100000 + 1),
            user_id: user.id,
            firstname: user.firstname,
            lastname: user.lastname,
            email: user.email,
            isExternalUser: isExternal,
        };
        return responsible_user;
    }

    private verification() {
        this.errors = [];
        if (this.selectedTrades.length === 0) {
            this.errors.push('trade');
        } else {
            this.errors.filter((err) => err !== 'trade');
        }

        if (!this.selectedPhase.hasOwnProperty('id')) {
            this.errors.push('phase');
        } else {
            this.errors.filter((err) => err !== 'phase');
        }

        if (this.selectedResponsibleUsers.length === 0) {
            this.errors.push('responsible_user');
        } else {
            this.errors.filter((err) => err !== 'responsible_user');
        }

        return this.errors.length === 0;
    }
}
